import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1E2A25] text-[#EFE8DD] mt-16">
      <div className="container-x pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center">
              <img
                src="https://customer-assets-gfyr7b9c.emergentagent.net/job_mhfa-course-hub/artifacts/1ae3h8nj_final%20logo%3A%20not%20right%20colour.png"
                alt="Rise Learning"
                className="h-48 md:h-56 w-auto object-contain scale-[2] -ml-16 md:-ml-24"
                style={{
                  transformOrigin: "left center",
                  // Cream tone that matches the paragraph text below (#EFE8DD/70)
                  filter:
                    "grayscale(1) invert(1) brightness(1.28) contrast(1.05) sepia(0.18) saturate(1.15) hue-rotate(-5deg)",
                  mixBlendMode: "screen",
                }}
              />
            </Link>
            <p className="mt-6 text-[#EFE8DD]/70 max-w-md leading-relaxed">
              Accredited Mental Health First Aid training for workplaces across the UK.
              Delivered with warmth and expertise.
            </p>
            <div className="mt-8 flex gap-3">
              <a
                href="https://www.linkedin.com/in/liz-milligan-a2851985"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-linkedin"
                className="w-10 h-10 rounded-full border border-[#EFE8DD]/20 flex items-center justify-center hover:bg-[#EFE8DD] hover:text-[#1E2A25] transition-colors"
              >
                <Linkedin className="w-4 h-4" strokeWidth={1.6} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h5 className="eyebrow text-[#D88C76] mb-5">Explore</h5>
            <ul className="space-y-3">
              <li><Link to="/courses" className="hover:text-[#D88C76] transition-colors">Courses</Link></li>
              <li><Link to="/about" data-testid="footer-link-about" className="hover:text-[#D88C76] transition-colors">About Us</Link></li>
              <li><Link to="/resources" className="hover:text-[#D88C76] transition-colors">Resources</Link></li>
              <li><Link to="/contact" className="hover:text-[#D88C76] transition-colors">Enquire</Link></li>
              <li><Link to="/admin" data-testid="footer-link-admin" className="hover:text-[#D88C76] transition-colors">Admin</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h5 className="eyebrow text-[#D88C76] mb-5">Get in touch</h5>
            <ul className="space-y-4 text-[#EFE8DD]/80">
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-1 text-[#D88C76]" />
                <a href="mailto:Liz@rise-learning.co.uk" data-testid="footer-email" className="hover:text-[#EFE8DD]">Liz@rise-learning.co.uk</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-1 text-[#D88C76]" />
                <div className="flex flex-col">
                  <a href="tel:+441462743761" data-testid="footer-phone" className="hover:text-[#EFE8DD]">+44 (0) 1462 743761</a>
                  <a href="tel:+447957281194" data-testid="footer-mobile" className="hover:text-[#EFE8DD] text-sm text-[#EFE8DD]/60 mt-0.5">Mobile: +44 (0) 7957 281194</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#D88C76]" />
                <span>Delivering courses UK-wide<br />Online & in-person</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#EFE8DD]/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#EFE8DD]/50">
          <span>© {new Date().getFullYear()} Rise Learning. Accredited by MHFA England.</span>
          <span className="italic font-serif-display text-base">Small courses. Lasting change.</span>
        </div>
      </div>
    </footer>
  );
}
